// extracted by mini-css-extract-plugin
export default {"heading":"styles_heading__8lMFV","modalContainer":"styles_modalContainer__ycrxP","saveButton":"styles_saveButton__75isz"};